export default {"src":"/_next/static/media/harold.7cb12cef.gif","height":320,"width":240,"blurWidth":0,"blurHeight":0};